<template>
  <div class="wrap">
    <div class="sticky-table">
      <table>
        <colgroup>
          <col style="width: 3.3em" />
          <col width="" />
          <col style="width: 5em" />
          <col style="width: 6.5em" />
        </colgroup>
        <thead>
          <tr>
            <th>번호</th>
            <th>체험실</th>
            <th>잔여인원</th>
            <th>신청인원</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="road in roadList">
            <tr :key="road.exhpHzCd">
              <th colspan="4">{{ road.exhpHallNm }}</th>
            </tr>
            <tr v-for="(exph, index) in road.exphList" :key="exph.exhpHzCd">
              <td>{{ index + 1 }}</td>
              <td>
                <Tooltip :text="exph.exhpHallExpl" :img="exph.imgFileNm" :upperCd="exph.upperCd">
                  <!-- 청체만 툴팁 노출 -->
                  <!-- <span v-if="exph.recomYn == 'Y' && exph.upperCd.startsWith('21')" class="recommend-icon">추천</span> -->
                  <span v-if="exph.recomYn == 'Y'" class="recommend-icon">추천</span>
                  <span>{{ exph.exhpHallNm }}</span>
                </Tooltip>
              </td>
              <td>{{ exph.exhpRvResiduePcnt }}</td>
              <td>
                <span v-if="radio">
                  <label class="radio-label">
                    <input
                      type="radio"
                      :value="exph.exhpHzCd"
                      :name="name"
                      :checked="exph.exhpHzCd === checked"
                      :disabled="exph.exhpRvResiduePcnt < 1"
                      @change="() => checkedPcnt(exph)"
                    />
                  </label>
                  ({{ exph.exhpAppPcnt }})
                </span>
                <count-button v-else :value="exph.exhpAppPcnt" :onChange="changePcnt" :max="exph.exhpRvResiduePcnt" :target="exph" :valid="valid" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <transition name="fade">
      <span v-if="timerId" class="error-msg">
        총
        <strong>{{ maxTotPcnt }}</strong>
        명 까지 선택 가능합니다.
      </span>
    </transition>
  </div>
</template>
transition
<script>
import CountButton from '@/components/common/CountButton.vue';
import Tooltip from '@/components/common/Tooltips.vue';

export default {
  components: {
    CountButton,
    Tooltip,
  },
  props: ['radio', 'name', 'checked', 'totPcnt', 'maxTotPcnt', 'roadList', 'onChange'],
  data: () => {
    return {
      timerId: '',
      error: false,
    };
  },
  computed: {},
  watch: {
    roadList() {
      this.clearPcntTimeout();
    },
  },
  methods: {
    changePcnt(value, target) {
      this.onChange(value, target);
    },
    checkedPcnt(value) {
      this.onChange(value);
    },
    clearPcntTimeout() {
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = '';
      }
    },
    valid(to, from) {
      if (this.maxTotPcnt > -1 && this.totPcnt - from + to > this.maxTotPcnt) {
        this.clearPcntTimeout();
        this.timerId = setTimeout(() => {
          this.timerId = '';
        }, 2500);
        return true;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    this.clearPcntTimeout();
  },
};
</script>

<style lang="scss" scoped>
table.vgt-table.vgt-cogent {
  font-size: 14px;

  thead th {
    background: #f5f5f5;
    padding: 0.5rem;
  }
}
.wrap {
  position: relative;
}

.sticky-table {
  max-height: 400px;
  overflow: auto;
  font-size: 16px;
  border: 1px solid #dcdfe6;

  & table {
    position: relative;
    border-collapse: collapse;

    th,
    td {
      padding: 0.25rem;
      text-align: center;
    }
    td:nth-child(2) {
      text-align: left;
    }
    th {
      background: white;
      position: sticky;
      z-index: 5;
    }
    thead th {
      height: 40px;
      padding: 8px 10px;
      font-weight: 500;
      color: #333;
      background: linear-gradient(#f4f5f8, #f1f3f6);
      top: 0px;
      box-shadow: 0 0 0, inset 0 -1px 0 rgba(0, 0, 0, 0.4);
    }
    tbody th {
      text-align: center;
      background: #fafafb;
      top: 40px;
      //box-shadow: 0 0 0, inset 0 -1px 0 rgba(0, 0, 0, 0.4);
    }
    tbody td {
      border-bottom: 1px solid #dcdfe6;

      & .recommend-icon {
        margin-right: 3px;
        padding: 0 10px;
        border-radius: 20px;
        font-weight: bold;
        color: #fff;
        background: #ff0000;
      }
      & .tooltip {
        width: inherit;
        height: inherit;
        line-height: inherit;
        font-weight: inherit;
        display: inherit;
        border-radius: none;
        text-align: inherit;
        font-size: inherit;
        background: none;
        color: inherit;
        cursor: pointer;
      }
      & .radio-label {
        width: 40px;
        height: 24px;
        display: inline-block;
      }
      & input[type='radio'] {
        -webkit-appearance: radio;
      }
    }
  }
}

@media all and (max-width: 540px) {
  .sticky-table {
    font-size: 14px;
  }
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-3px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(3px, 0, 0);
  }
}

.fade-enter-active {
  animation: shake 0.54s cubic-bezier(0.34, 0.05, 0.17, 0.75) both;
  transform: translate3d(0, 0, 0);
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.error-msg {
  position: absolute;
  display: inline-block;
  width: 100%;
  background: #fff0edd3;
  border: 1px solid #e74c3c;
  color: #333;
  text-align: center;
  top: 0;
  z-index: 5;
  height: 40px;
  line-height: 40px;
}
</style>
